import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { HashRouter } from 'react-router-dom';
import App from 'App';
import createStore from './store';
import { QueryClient, QueryClientProvider } from 'react-query';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { fetchJson } from 'api/http-service';
import { getEnv } from 'api/http-service';
import ReactGA from "react-ga4";

export const store = createStore();
let persistor = persistStore(store);

export const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false, retry: false }}});

const getConfig = (async () => {

  const { recaptchaSiteKey, googleAnalyticsID, urls } = await getEnv;

  !!googleAnalyticsID && ReactGA.initialize(googleAnalyticsID);

  const {languages: localesLanguages} = await fetchJson('./locales/languages.json').catch((error) => { console.error(error); console.log('Can not get languages.json'); });

  const localeEntries = await Promise.all(localesLanguages.map(fetchLocale));

  const locales = Object.fromEntries(localeEntries.filter(Boolean));
  return { recaptchaSiteKey, locales, urls };
})()

const domNode = document.getElementById('root');
const root = createRoot(domNode);

root.render(
  await getConfig.then((config)=> {
    return (
      <HashRouter>
        <QueryClientProvider client={queryClient} >
          <ReduxProvider store={store}>
            <PersistGate persistor={persistor}>
              <App {...config} />
            </PersistGate>
          </ReduxProvider>
        </QueryClientProvider>
      </HashRouter>
    )
  })
)

async function fetchLocale (key) {
  return fetchJson(`./locales/${key}.json`).then(locale => [key, locale]).catch(() => null);
}